import { topicsData } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[500px] mx-auto">
            大家都在关注的内容标签与热度信息
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((item, i) => (
            <a
              key={i}
              href={item.href}
              onClick={(e) => {
                e.preventDefault();
                const el = document.querySelector(item.href);
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group inline-flex items-center gap-2 px-5 py-3 rounded-full border border-background-200/70 bg-background-50 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 whitespace-nowrap">
                {item.label}
              </span>
              <span className="text-xs text-foreground-400 bg-background-100 px-2 py-0.5 rounded-full whitespace-nowrap">
                {item.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}